import { Being, BeingState } from "../../../models/Being";
import { Surroundings } from "../../../models/Surroundings";
import { IBeingState } from "./IBeingState";

export class DeadState implements IBeingState {
    static readonly stateName = 'Dead';

    get allowInterrupt(): boolean {
        return false;
    }

    canEnter(being: Being, _surroundings: Surroundings): boolean {
        return being.health <= 0;
    }

    tick(_being: Being, _surroundings: Surroundings): BeingState {
        return DeadState.stateName;
    }
}